// Shared by the blog index's pages and its component, so nothing here may touch
// the filesystem: this module ships in the browser bundle.

/** The most posts one page of the blog index lists. */
export const POSTS_PER_PAGE = 10;

/**
 * Every category a post can belong to, in the order the index offers them. A
 * post names its category by slug in its frontmatter (`category: pcs`), and the
 * build fails on a post without one of these, rather than leaving it out of
 * every filter. The description is the category page's meta description, so it
 * should still hold true as posts are added.
 */
export const CATEGORIES = [
  {
    slug: "ai-architecture",
    name: "AI Architecture",
    description: "How large language models work inside, with interactive 3D walkthroughs of real model architectures."
  },
  {
    slug: "pcs",
    name: "PCs",
    description: "Guides to setting up Windows PCs, from a clean Windows 11 install to streaming games to a Steam Deck."
  },
  {
    slug: "random-thoughts",
    name: "Random Thoughts",
    description: "Opinions on programming, principles for using AI well, and side projects."
  }
];

/** Where one page of the index lives. `category` null is all posts; page 1 carries no page segment. */
export function blogIndexHref(category: string | null, page = 1) {
  const base = category ? `/blog/category/${category}` : "/blog";
  return page > 1 ? `${base}/page/${page}` : base;
}

/**
 * What a post was made with, from its `madeWith` frontmatter: the AI models and
 * the main tools, as a plain list. Sam's call: "they are not humans, but are
 * tools I used to create this, listing used tools is enough", so no roles.
 * Throws on anything but a list of names, so a slip fails the build rather than
 * the page.
 */
export function madeWithSentence(madeWith: unknown, slug: string): string | null {
  if (madeWith === undefined) return null;
  if (
    !Array.isArray(madeWith) ||
    !madeWith.length ||
    !madeWith.every((tool) => typeof tool === "string" && tool.trim())
  ) {
    throw new Error(`${slug}: madeWith must be a list of names, such as ["Claude Opus 5.5", "three.js"]`);
  }
  return madeWith.length === 1 ? madeWith[0] : `${madeWith.slice(0, -1).join(", ")} and ${madeWith.at(-1)}`;
}

export function pageCount(postCount: number) {
  return Math.max(1, Math.ceil(postCount / POSTS_PER_PAGE));
}
